"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMainDomain = void 0;
/**
 * 根据当前url的主域名
 * @return {string}
 */
function getMainDomain() {
    var s = location.hostname.split('.');
    var len = s.length;
    return s[len - 2] + '.' + s[len - 1];
}
exports.getMainDomain = getMainDomain;
//# sourceMappingURL=domain.js.map